import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as  XLSX from 'xlsx'
import { DataServiceProvider } from '../data-service/data-service';


@Injectable()
export class ExportServiceProvider {

  constructor(public http: HttpClient, public dataService: DataServiceProvider) {
  }
  download(blob, filename) {
    var a = document.createElement("a"),
      url = URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }

  excelUpload(event) {
    let excelFile = event.target.files[0];
    if(excelFile != undefined){
    var exelFiles = excelFile.name.split('.');
    if (exelFiles[1] == "xlsx") {
      let workBook = null;
      let jsonData = null;
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        this.dataService.broadcastInfo({ src: 'proposal-create', event: 'loadAzureData', params:  jsonData});
      }
      reader.readAsBinaryString(excelFile);
    } else {
      alert('invaild format')
    }
  }
  }
}



// WEBPACK FOOTER //
// ./src/providers/export-service/export-service.ts